import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const LoaderOutlinedSize64Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 7.46663C27.1478 7.46663 22.4045 8.90548 18.37 11.6012C14.3356 14.297 11.1911 18.1286 9.33419 22.6115C7.47732 27.0943 6.99148 32.0272 7.9381 36.7862C8.88472 41.5452 11.2213 45.9166 14.6523 49.3476C18.0834 52.7787 22.4548 55.1153 27.2138 56.0619C31.9728 57.0085 36.9056 56.5227 41.3885 54.6658C45.8714 52.8089 49.703 49.6644 52.3987 45.6299C55.0945 41.5955 56.5334 36.8522 56.5334 32H61.3334C61.3334 37.8015 59.613 43.4728 56.3898 48.2967C53.1666 53.1205 48.5854 56.8802 43.2254 59.1004C37.8654 61.3206 31.9675 61.9015 26.2774 60.7696C20.5873 59.6378 15.3606 56.8441 11.2582 52.7417C7.15589 48.6394 4.36216 43.4127 3.23033 37.7226C2.0985 32.0325 2.6794 26.1345 4.89957 20.7746C7.11974 15.4146 10.8795 10.8334 15.7033 7.61018C20.5271 4.387 26.1984 2.66663 32 2.66663V7.46663Z"
                fill="var(--magritte-ui-icon-color)"
            />
        </g>
    </svg>
);
const LoaderOutlinedSize64 = hoc<'LoaderOutlinedSize64'>(
    forwardRef(LoaderOutlinedSize64Component),
    'LoaderOutlinedSize64'
);
export default LoaderOutlinedSize64;
